import * as React from "react";
import { observer } from "mobx-react";

import { CarsFormHotwireView } from "../components/CarsFormView/CarsFormHotwireView";
import { WizardCarPWAViewProps, WizardCarPWAFTNodeOptions } from "../typings";
import { useHotwireCarOverrides } from "components/flexComponents/WizardCarPWA/utils/hotwireCarOverrides";

import { normalizeOptionsData } from "src/stores/FlexTemplateStore";

export const WizardCarPWAHotwireView: React.FunctionComponent<WizardCarPWAViewProps> = observer(
  ({
    isDiffDropOff,
    onDifferentDropOffSelected,
    setIsDifferentDropOff,
    wizardState: { globalWizardState, carWizardState },
    setInputsRefs,
    getLocError,
    flexModuleModelStore,
    flexTemplateNode,
  }) => {
    useHotwireCarOverrides(carWizardState);
    const { config } = carWizardState;
    const model = flexModuleModelStore.getModel(flexTemplateNode.id);
    const options = normalizeOptionsData(flexTemplateNode, model) as WizardCarPWAFTNodeOptions;

    return (
      <form
        noValidate
        action={config.form.action}
        autoComplete="off"
        className="WizardCarPWA"
        id={config.elementId}
        data-fm={options.fmId}
        data-fm-title-id={options.fmTitleId}
        data-module="searchCarForm"
        onSubmit={carWizardState.submit}
      >
        <CarsFormHotwireView
          flexTemplateNode={flexTemplateNode}
          setInputsRefs={setInputsRefs}
          carWizardState={carWizardState}
          carConfig={config}
          onDifferentDropOffSelected={onDifferentDropOffSelected}
          setIsDifferentDropOff={setIsDifferentDropOff}
          isDiffDropOff={isDiffDropOff}
          getLocError={getLocError}
          globalConfig={globalWizardState.config}
        />
      </form>
    );
  }
);

export default WizardCarPWAHotwireView;
